class ValidarPlaca {
  normalizar(placa) {
    if (typeof placa !== "string") return "";
    return placa.toUpperCase().replace(/[^A-Z0-9]/g, "");
  }

  validar(placa) {
    const normalizada = this.normalizar(placa);
    return (
      REGEX_PLACA_ANTIGA.test(normalizada) ||
      REGEX_PLACA_MERCOSUL.test(normalizada)
    );
  }
}

const REGEX_PLACA_ANTIGA = /^[A-Z]{3}[0-9]{4}$/;
const REGEX_PLACA_MERCOSUL = /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/;

export default ValidarPlaca;
